module.exports = __webpack_public_path__ + "img/H01120-158.fbf99d9d.jpg";